<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: { type: Boolean, required: true }, // v-model Prop
    document: { type: Object, required: true }
  },
  data() {
    return {
      tempNote: '',
    };
  },
  computed: {
    ...mapGetters(['selectedContext']),
    dialogWidth() {
      return '40%';
    },
    isReadonly() {
      return this.selectedContext === 'closed' || this.selectedContext === 'unknown';
    },
    editableNote: {
      get() {
        return this.document?.userNote || '';
      },
      set(value) {
        this.tempNote = value;
      }
    },
    dialogValue: {
      get() {
        return this.value;
      },
      set(val) {
        return val ? this.$emit('cancel') : this.tempNote = '';
      }
    }
  },
  methods: {
    save() {
      this.$emit('saveNote', { document: this.document, inboxNote: this.tempNote });
      this.editableNote = '';
    },
    cancel() {
      this.editableNote = '';
      this.$emit('cancel');
    },
  }
};
</script>
<template>
  <v-dialog v-model="dialogValue" :width="dialogWidth" scrollable @click:outside="cancel" @keydown.esc="cancel">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>
            {{ $t('component.inbox.create.note') }}
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-subtitle>
        <small>{{ $t('global.document') }} #{{ document && document.workItemId }}</small>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text class="mt-3">
        <v-textarea
          v-model="editableNote"
          :label="$t('component.inbox.write.note')"
          outlined
          clearable
          hide-details
          rows="5"
          :readonly="isReadonly"
        ></v-textarea>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex">
        <v-btn class="flex-grow-1" color="secondary" @click="cancel">
          {{ $t('button.cancel') }}
        </v-btn>
        <v-btn v-if="!isReadonly" class="flex-grow-1" color="primary" @click="save">
          {{ $t('button.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
